import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "edit-form" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "collapse-content" }
const _hoisted_9 = { class: "collapse-content" }
const _hoisted_10 = { class: "new-form" }
const _hoisted_11 = { class: "collapse-content" }
const _hoisted_12 = { class: "collapse-content" }
const _hoisted_13 = { class: "collapse-content" }
const _hoisted_14 = { class: "collapse-content" }
const _hoisted_15 = { class: "new-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_List = _resolveComponent("List")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_EditPen = _resolveComponent("EditPen")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_LocationFilled = _resolveComponent("LocationFilled")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.CUSTOMER,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['CUST_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.customerModel && _ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Mandant', '/customer'], [_ctx.customerModel.name]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_List)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title-label" }, "Stammdaten", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_form, {
                                  ref: "editCustomerForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.customerModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Name",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.name,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.customerModel.name) = $event)),
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.description,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.customerModel.description) = $event)),
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Straße",
                                      prop: "street"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.street,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.customerModel.street) = $event)),
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "PLZ",
                                      prop: "zipcode"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.zipcode,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.customerModel.zipcode) = $event)),
                                          maxlength: 5,
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Ort",
                                      prop: "city"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.city,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.customerModel.city) = $event)),
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "E-Mail",
                                      prop: "email"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.email,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.customerModel.email) = $event)),
                                          onInput: _ctx.onCustomerInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Ticket Präfix",
                                      prop: "tokenprefix"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.customerModel.tokenprefix,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.customerModel.tokenprefix) = $event)),
                                          onInput: _ctx.onCustomerInput,
                                          maxlength: 2
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formCustomerValid,
                                          onClick: _ctx.onCustomerSaveClick
                                        }, {
                                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                                            _createTextVNode("Speichern ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "2" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_UserFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title-label" }, "Ansprechpartner", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.contactModelList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "contactid",
                                    label: "ID",
                                    width: "60"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Bezeichnung"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "firstname",
                                    label: "Vorname",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "lastname",
                                    label: "Nachname",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "email",
                                    label: "E-Mail",
                                    width: "200"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "phone",
                                    label: "Telefon",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateupdate",
                                    label: "Datum",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.contactModelList[scope.$index].dateupdate))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: $event => (_ctx.onContactEditClick(_ctx.contactModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_EditPen)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        onClick: $event => (_ctx.onContactDeleteClick(_ctx.contactModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "3" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "title-label" }, "Neuer Ansprechpartner", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_el_form, {
                                  ref: "newContactForm",
                                  rules: _ctx.newContactModel.contacttypeid == 1 ? _ctx.rulesContact1 : _ctx.newContactModel.contacttypeid == 2 ? _ctx.rulesContact2 : _ctx.rulesContact3,
                                  "label-position": "top",
                                  model: _ctx.newContactModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Bezeichnung",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.name,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.newContactModel.name) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Art des Ansprechpartners",
                                      prop: "contacttypeid",
                                      placeholder: "Bitte wählen..."
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.newContactModel.contacttypeid,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.newContactModel.contacttypeid) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: "0",
                                              label: "Bitte wählen...",
                                              value: 0
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactTypeModelList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.contacttypeid,
                                                label: item.name,
                                                value: item.contacttypeid
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Anrede",
                                      prop: "salutation"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.salutation,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.newContactModel.salutation) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Abteilung innerhalb der Organisation",
                                      prop: "department"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.department,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.newContactModel.department) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Vorname",
                                      prop: "firstname"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.firstname,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.newContactModel.firstname) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Nachname",
                                      prop: "lastname"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.lastname,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.newContactModel.lastname) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "E-Mail",
                                      prop: "email"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.email,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.newContactModel.email) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Telefon (Festnetz)",
                                      prop: "phone"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.phone,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.newContactModel.phone) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Mobiltelefon",
                                      prop: "mobile"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newContactModel.mobile,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.newContactModel.mobile) = $event)),
                                          onInput: _ctx.onContactInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formContactValid,
                                          onClick: _ctx.onNewContactClick
                                        }, {
                                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                                            _createTextVNode(" Hinzufügen ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "4" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_LocationFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "title-label" }, "Standorte", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.locationModelList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "locationid",
                                    label: "ID",
                                    width: "80"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Bezeichnung",
                                    width: "200"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "description",
                                    label: "Beschreibung"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "zipcode",
                                    label: "PLZ",
                                    width: "80"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "city",
                                    label: "Ort",
                                    width: "150"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateupdate",
                                    label: "Datum",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.locationModelList[scope.$index].dateupdate))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: $event => (_ctx.onLocationEditClick(_ctx.locationModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_EditPen)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        onClick: $event => (_ctx.onLocationDeleteClick(_ctx.locationModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "5" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "title-label" }, "Neuer Standort", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_el_form, {
                                  ref: "newLocationForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.newLocationModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Name",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.name,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.newLocationModel.name) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Beschreibung",
                                      prop: "description"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.description,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.newLocationModel.description) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Strasse",
                                      prop: "street"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.street,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.newLocationModel.street) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Postleitzahl",
                                      prop: "zipcode"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.zipcode,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.newLocationModel.zipcode) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Ort",
                                      prop: "city"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.city,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.newLocationModel.city) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Region",
                                      prop: "region"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.region,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.newLocationModel.region) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Land",
                                      prop: "country"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newLocationModel.country,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.newLocationModel.country) = $event)),
                                          onInput: _ctx.onLocationInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formLocationValid,
                                          onClick: _ctx.onNewLocationClick
                                        }, {
                                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                                            _createTextVNode(" Hinzufügen ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}